import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorFSBonusFeaturePlayingController} from "../../reelstoppresentation/fsbonusfeature/ThorFSBonusFeaturePlayingController";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorRandomWildsWPController} from "../randomwilds/ThorRandomWildsWPController";

/**
 * Created by Jerker Nord on 2019-06-24.
 */

export class ThorReelWildsWPController extends WinPresentationController {

    private _reelWildsPlaying:boolean;
    private _iconSelectanimationPlaying:boolean = false;
    private _addNewWildsTL:TimelineLite;
    private _FSFeatureSelectEnded:boolean = false;
    private _FSMjolnirAnimationAborted:boolean = false;
    private _disableWilds:boolean;
    private _disableOverlayWildsTL:TimelineLite;
    private _wildReelsAwardedThisSpin:boolean[];
    private _newOverlayWildsAfterSpinStop:boolean[][];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "ThorReelWildsWP", skippable : true});
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        this._newOverlayWildsAfterSpinStop = this.getNewWilds(data.overlayWildsBeforeSpinStop, data.overlayWildsAfterSpinStop);
        this._reelWildsPlaying = false;
        this._iconSelectanimationPlaying = false;
        this._FSMjolnirAnimationAborted = false;
        this._disableWilds = false;
        this._wildReelsAwardedThisSpin = data.wildReelsAwardedThisSpin;
        if(data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN && data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_WILD_REELS_FEATURE) {
            this._iconSelectanimationPlaying = true;
        }
        if((data.mode == ThorGameMode.FREESPIN || data.mode == ThorGameMode.NUDGE_RESPIN_FS) && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS && data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_WILD_REELS_FEATURE) {
            this._iconSelectanimationPlaying = true;
        }
        if((data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NORMAL) || (data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode !== ThorGameMode.NUDGE_RESPIN_FS)) {
            this._disableWilds = true;
        }
    }

    private getNewWilds(wildsBefore:boolean[][], wildsAfter:boolean[][]):boolean[][] {
        let newWilds:boolean[][] = [[false, false, false], [false, false, false], [false, false, false], [false, false, false], [false, false, false]];

        for(let i:number = 0; i < wildsAfter.length; i++) {
            for(let j:number = 0; j < wildsAfter[i].length; j++) {
                if(wildsAfter[i][j] == true && wildsBefore[i][j] == false) {
                    newWilds[i][j] = true;
                } else {
                    newWilds[i][j] = false;
                }
            }
        }
        return newWilds;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ThorRandomWildsWPController.ICON_SELECT_ANIMATION_COMPLETE, ():void => this.onIconSelectanimationComplete());
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_FEATURE_SELECT_ENDED, ():void => this.onFSFeatureSelectEnded());
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_MJOLNIR_ANIMATION_ABORTED, ():void => this.onMjolnirAnimationAborted());
    }

    private onMjolnirAnimationAborted():void {
        this._FSMjolnirAnimationAborted = true;
    }

    private onFSFeatureSelectEnded():void {
        if(this._iconSelectanimationPlaying == true) {
            this._FSFeatureSelectEnded = true;
        }
    }

    private onIconSelectanimationComplete():void {
        if(this._iconSelectanimationPlaying == true) {
            if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
                this._addNewWildsTL.pause();
                this._addNewWildsTL.kill();
            }
            this._addNewWildsTL = new TimelineLite();
            this._addNewWildsTL.add(() => this._reelWildsPlaying = true);
            this._addNewWildsTL.add(ThorGameModuleConfig.thorReelWildsView.getAddNewWildsTL(this.getWildReels()));
            this._addNewWildsTL.add(() => this._reelWildsPlaying = false);
            this._addNewWildsTL.add(() => {
                this.finish();
            });
        }
    }

    private getWildReels():boolean[][] {
        let overlayWildReels:boolean[][] = [[false, false, false], [false, false, false], [false, false, false], [false, false, false], [false, false, false]];

        for(let i:number = 0; i < this._newOverlayWildsAfterSpinStop.length; i++) {
            for(let j:number = 0; j < this._newOverlayWildsAfterSpinStop[i].length; j++) {
                if(this._newOverlayWildsAfterSpinStop[i][j] == true) {
                    overlayWildReels[i][0] = true;
                    overlayWildReels[i][1] = true;
                    overlayWildReels[i][2] = true;
                }
            }
        }
        return overlayWildReels;
    }

    protected hasWin():boolean {
        if(this._iconSelectanimationPlaying || this._reelWildsPlaying || this._disableWilds) {
            return true;
        }
        return false;
    }

    protected startWinPresentation():void {
        Logger.logDev(`${this.moduleName} startWinPresentation this._iconSelectanimationPlaying=${this._iconSelectanimationPlaying}, this._reelWildsPlaying=${this._reelWildsPlaying}, this._disableWilds=${this._disableWilds}, this._FSFeatureSelectEnded=${this._FSFeatureSelectEnded}`)
        if(this._iconSelectanimationPlaying == false && this._reelWildsPlaying == false && this._disableWilds == false) {
            this.finish();
        }
        if(this._FSFeatureSelectEnded) {
            this._FSFeatureSelectEnded = false;
            this.onIconSelectanimationComplete();
        }
        if(this._disableWilds == true) {
            this.onDisableOverlayWilds();
        }
    }

    private onDisableOverlayWilds():void {
        if(this._disableOverlayWildsTL && this._disableOverlayWildsTL.isActive()) {
            this._disableOverlayWildsTL.pause();
            this._disableOverlayWildsTL.kill();
        }
        this._disableOverlayWildsTL = new TimelineLite();
        this._disableOverlayWildsTL.add(ThorGameModuleConfig.thorReelWildsView.disableOverlayWilds());
        this._disableOverlayWildsTL.add(() => this.finish());
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            if(this._disableWilds == true) {
                if(this._disableOverlayWildsTL && this._disableOverlayWildsTL.isActive()) {
                    this._disableOverlayWildsTL.pause();
                    this._disableOverlayWildsTL.kill();
                }
                ThorGameModuleConfig.thorReelWildsView.abortDisableOverlayWilds();
            }
            if(this._iconSelectanimationPlaying == true) {
                if(this._FSMjolnirAnimationAborted == false) {
                    ThorGameModuleConfig.thorMjolnirtimeView.abort();
                }
                ThorGameModuleConfig.thorReelWildIconView.abort();
            }
            if(this._reelWildsPlaying == true) {
                this._reelWildsPlaying = false;
                if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
                    this._addNewWildsTL.pause();
                    this._addNewWildsTL.kill();
                }
            }
            ThorGameModuleConfig.thorReelWildsController.abort();
            ThorGameModuleConfig.thorReelWildsView.abort(this.getWildReels());
        }
    }
}